import createCachedSelector from 're-reselect'
import { emptyObj } from 'util/objects'
import { USAGE_KB_KBS } from 'ducks/billing/usageTypes'
import { selectBillingUsage } from '../selectBillingUsage'
import { INBOX, KB } from '../../productTypes'
import { byProductCacheKey } from './byProductCacheKey'

export const selectBillingUsageForProduct = createCachedSelector(
  selectBillingUsage,
  (_state, product) => product,
  (usage, product) => {
    if (product === INBOX && usage[product]) {
      // Include kb usage in inbox usage for inbox plans that has max_kbs feature
      // and need to calculate kb's usage using isPlanLimitsExceeded
      return { ...usage[product], [USAGE_KB_KBS]: usage[KB]?.[USAGE_KB_KBS] }
    }
    return usage[product] || emptyObj
  }
)(byProductCacheKey)
